import "./BulkPatientViewComponent.scss";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {useCallback, useEffect, useState} from "react";
import CommonService from "../../../shared/services/common.service";
import {IAPIResponseType} from "../../../shared/models/api.model";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import CardComponent from "../../../shared/components/card/cardComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import Grid from "@mui/material/Grid";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import DrawerComponent from "../../../shared/components/drawer/drawerComponent";
import {ImageConfig} from "../../../constants";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import commonService from "../../../shared/services/common.service";
import ImportBulkPatientComponent from "../import-bulk-patient/importBulkPatientComponent";
import BulkPatientSessionListComponent from "../bulk-patient-session-list/BulkPatientSessionListComponent";
import DialogComponent from "../../../shared/components/dialog/dialogComponent";
import PatientInsuranceConflictComponent
    from "../../../shared/components/patient-insurance-conflict/PatientInsuranceConflictComponent";
import BadgeComponent from "../../../shared/components/badge/BadgeComponent";

interface BulkPatientViewComponentProps {

}

interface patientModalConfigType {
    type: 'uploading' | 'generating',
    isOpen: boolean,
    totalCount: number,
    progressCount: number,
}

const initialPatientModalConfig: patientModalConfigType = {
    type: 'uploading',
    isOpen: false,
    totalCount: 0,
    progressCount: 0,
}

interface bulkOrderCountType {
    /**
     * For Fresh Patient Generate
     */
    validPatientCount: number,
    /**
     * For Invalid fields email trigger
     */
    invalidPatientCount: number,
    /**
     * For Insurance conflict
     */
    conflictPatientCount: number,
    /**
     * Total count of patient in Excel file
     */
    uploadedCount: number,
    totalCount: number

}

const MODULE_NAME = 'bulk-patient-list';
const BulkPatientViewComponent = (props: BulkPatientViewComponentProps) => {
    const params = useParams<{ bulkPatientID: string }>();
    const {bulkPatientID} = params;
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [bulkOrderDetails, setBulkOrderDetails] = useState<any>(undefined);
    const [bulkOrderCount, setBulkOrderCount] = useState<bulkOrderCountType>();
    const [isBulkOrderDetailsLoading, setIsBulkOrderDetailsLoading] = useState<boolean>(false);
    const [isBulkOrderDetailsLoaded, setIsBulkOrderDetailsLoaded] = useState<boolean>(false);
    const [isBulkOrderDetailsLoadingFailed, setIsBulkOrderDetailsLoadingFailed] = useState<boolean>(false);
    const [isImportPatientDrawerOpen, setIsImportPatientDrawerOpen] = useState<boolean>(false);
    const [isGenerateResultLoading, setIsGenerateResultLoading] = useState<boolean>(false);
    const [patientModalConfig, setPatientModalConfig] = useState(initialPatientModalConfig);

    const getBulkOrderDetails = useCallback(() => {
        const payload = {};
        let bulkOrderDetails: any = {};
        setIsBulkOrderDetailsLoading(true);
        setIsBulkOrderDetailsLoaded(false);
        setIsBulkOrderDetailsLoadingFailed(false);
        CommonService._patient.getBulkPatientDetails(bulkPatientID, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    bulkOrderDetails = response.data;
                }
                setBulkOrderDetails(bulkOrderDetails);
                setIsBulkOrderDetailsLoading(false);
                setIsBulkOrderDetailsLoaded(true);
                setIsBulkOrderDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setBulkOrderDetails(bulkOrderDetails);
                setIsBulkOrderDetailsLoading(false);
                setIsBulkOrderDetailsLoaded(false);
                setIsBulkOrderDetailsLoadingFailed(true);
            });
    }, [bulkPatientID]);

    const [isCountLoading, setIsCountLoading] = useState(false);
    const getUpdatedListCount = useCallback(() => {
        setIsCountLoading(true)
        CommonService._patient.getBulkPatientListCount(bulkPatientID).then(res => {
            setBulkOrderCount(res.data as bulkOrderCountType)
        }).finally(() => {
            setIsCountLoading(false)
        })
    }, [bulkPatientID])

    const getBulkPatientListCount = useCallback(() => {
        setIsBulkOrderDetailsLoading(true);
        CommonService._patient.getBulkPatientListCount(bulkPatientID).then(res => {
            const {
                uploadedCount,
                totalCount
            } = (res.data || {}) as bulkOrderCountType;
            setBulkOrderCount(res.data as bulkOrderCountType)
            // const mockResponse = {
            //     "totalCount": 100,
            //     "uploadedCount": 100,
            //     "notUploadedCount": 0
            // }
            setPatientModalConfig({
                type: 'uploading',
                isOpen: uploadedCount < totalCount,
                totalCount: totalCount,
                progressCount: uploadedCount,
            });
            if (uploadedCount < totalCount) {
                setTimeout(() => {
                    getBulkPatientListCount()
                }, 1000)
            } else {
                //Adding 5 seconds delay to get correct count, we may get wrong count if we call this api instantly.
                setTimeout(getBulkOrderDetails, 5000);
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: MODULE_NAME
                })
                setTimeout(() => {
                    setPatientModalConfig({
                        type: 'uploading',
                        isOpen: false,
                        totalCount: 0,
                        progressCount: 0,
                    });
                }, 500)
            }
        })
    }, [bulkPatientID, getBulkOrderDetails])

    const getBulkPatientGeneratedCount = useCallback(() => {
        CommonService._patient.getBulkPatientGeneratedCount(bulkPatientID).then(res => {
            const {totalValidPatientCount, validPatientGeneratedCount} = res.data || {};
            // data = {
            //     "totalCount": 100,
            //     "generatedCount": 100,
            //     "notGeneratedCount": 0
            // }
            setPatientModalConfig({
                type: 'generating',
                isOpen: true,
                totalCount: totalValidPatientCount,
                progressCount: validPatientGeneratedCount,
            });
            if (validPatientGeneratedCount < totalValidPatientCount) {
                setTimeout(() => getBulkPatientGeneratedCount(), 1000)
            } else {
                getBulkOrderDetails();
                //Calling after .5 seconds because to show the 100% progress
                setTimeout(() => {
                    setPatientModalConfig({
                        type: 'generating',
                        isOpen: false,
                        totalCount: 0,
                        progressCount: 0,
                    });
                    setIsGenerateResultLoading(false);
                }, 500)
            }
        })
    }, [bulkPatientID, getBulkOrderDetails])

    const generateResult = useCallback(() => {
        const payload = {};
        setIsGenerateResultLoading(true)
        getBulkPatientGeneratedCount();
        CommonService._patient.generateBulkPatients(bulkPatientID, payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response?.message || "Generated Successfully", 'success');
            })
            .catch((error: any) => {
                setIsGenerateResultLoading(false);
                CommonService._alert.showToast(error?.error || 'Error Generating Result', 'error');
            });
    }, [bulkPatientID, getBulkPatientGeneratedCount]);

    const initialInsuranceModalConfig = {isOpen: false}
    const [insuranceModalConfig, setInsuranceModalConfig] = useState(initialInsuranceModalConfig)
    const handleInsuranceConflict = useCallback(() => {
        setInsuranceModalConfig((prev) => {
            return {...prev, isOpen: true}
        })
    }, [])

    const [isEmailTriggerLoading, setEmailTriggerLoading] = useState(false);
    const handleEmailTrigger = useCallback(() => {
        setEmailTriggerLoading(true)
        CommonService._patient.sendInvalidBulkPatientEmail(bulkPatientID!).then((response) => {
            CommonService._alert.showToast(response?.message || "Email triggered successfully", 'success');
            searchParams.set("emailTriggered", "true");
            setSearchParams(searchParams);
        }).catch((error) => {
            CommonService._alert.showToast(error?.error || 'Error triggering email', 'error');
        }).finally(() => {
            setEmailTriggerLoading(false);
        })
    }, [bulkPatientID, searchParams, setSearchParams])

    const handleEmailConfirmation = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Please confirm!',
            confirmationSubTitle: 'Invalid entries from this bulk upload will be emailed. They will not be generated inside the system.',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: "Send Email",
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "primary"
            }
        }).then(() => {
            handleEmailTrigger()
        }).catch(() => {
            // do nothing;
        });
    }, [handleEmailTrigger])

    useEffect(() => {
        if (bulkPatientID) {
            getBulkPatientListCount();
        }
    }, [bulkPatientID, getBulkPatientListCount]);

    return (
        <div className={'bulk-upload-view-component view-screen screen'}>
            <div className="view-details-wrapper">
                {
                    (isBulkOrderDetailsLoading && !isBulkOrderDetailsLoaded) && <div className="h-v-center">
                        <LottieFileGenarationComponent
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.LoadingLottieFile}/>
                    </div>
                }
                {
                    isBulkOrderDetailsLoadingFailed && <>
                        <StatusCardComponent title={"BulkOrder details failed to load"}/>
                    </>
                }
                {
                    isBulkOrderDetailsLoaded && <div className="view-details-wrapper">
                        <CardComponent className={'view-details-header-wrapper'}>
                            <div className="card-content">
                                <div className="view-details-card-header-button-wrapper">
                                    <div className="view-details-card-title">
                                        {bulkOrderDetails?.title}
                                    </div>
                                    <div className="view-details-options d-flex justify-content-space-between">
                                        <ButtonComponent
                                            type="button"
                                            color={"secondary"}
                                            disabled={!(bulkOrderDetails?.numberOfInValidPatients > 0)}
                                            variant={"outlined"}
                                            handleClick={() => setIsImportPatientDrawerOpen(true)}
                                        >
                                            Re-upload XLS
                                        </ButtonComponent> &nbsp;&nbsp;
                                        <BadgeComponent badgeContent={bulkOrderCount?.conflictPatientCount} color="primary">
                                            <ButtonComponent
                                                type="button"
                                                color={"primary"}
                                                isLoading={isCountLoading}
                                                disabled={bulkOrderCount?.conflictPatientCount === 0}
                                                variant={"contained"}
                                                handleClick={handleInsuranceConflict}
                                            >

                                                Insurance Conflicts
                                            </ButtonComponent>
                                        </BadgeComponent>
                                        <BadgeComponent badgeContent={bulkOrderCount?.invalidPatientCount} color="primary">
                                            <ButtonComponent
                                                type="button"
                                                color={"primary"}
                                                isLoading={isCountLoading || isEmailTriggerLoading}
                                                disabled={bulkOrderCount?.invalidPatientCount === 0 || searchParams.get("emailTriggered") === "true"}
                                                variant={"contained"}
                                                handleClick={handleEmailConfirmation}
                                            >
                                                Trigger Email
                                            </ButtonComponent>
                                        </BadgeComponent>
                                        <BadgeComponent badgeContent={bulkOrderCount?.validPatientCount} color="primary">
                                            <ButtonComponent
                                                type="button"
                                                color={"primary"}
                                                // disabled={bulkOrderDetails?.numberOfInValidPatients > 0 || bulkOrderDetails?.isGenerated}
                                                disabled={bulkOrderDetails?.isGenerated || bulkOrderCount?.validPatientCount === 0}
                                                isLoading={isGenerateResultLoading || isCountLoading}
                                                variant={"contained"}
                                                handleClick={generateResult}
                                            >
                                                Create Patients
                                            </ButtonComponent>
                                        </BadgeComponent>
                                    </div>
                                </div>
                                <div className="view-details-content">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Added On"}>
                                                <div
                                                    className="view-details-value"> {commonService.formatDate(bulkOrderDetails?.createdAt)} </div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Added by"}
                                                maxLength={19}>
                                                {bulkOrderDetails?.createdByDetails?.firstName + " " + bulkOrderDetails?.createdByDetails?.lastName}
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Facility"}
                                                maxLength={19}
                                            >
                                                {bulkOrderDetails?.facilityDetails?.name}
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Location"}
                                                maxLength={19}
                                            >
                                                {bulkOrderDetails?.locationDetails?.name}
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Valid Entries"}>
                                                {/*<div*/}
                                                {/*    className="details-value">{bulkOrderDetails?.numberOfValidPatients} </div>*/}
                                                <div
                                                    className="details-value">{bulkOrderCount?.validPatientCount} </div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Invalid Entries"}>
                                                {/*<div*/}
                                                {/*    className="details-value"> {bulkOrderDetails?.numberOfInValidPatients} </div>*/}
                                                <div
                                                    className="details-value"> {bulkOrderCount?.invalidPatientCount} </div>

                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </CardComponent>

                        <div className="page-data-wrapper t-table-inside-details mrg-top-25 mrg-right-20 mrg-left-20">
                            <BulkPatientSessionListComponent
                                bulkPatientID={bulkPatientID}
                                dataColumns={bulkOrderDetails?.dataColumns}
                                moduleName={MODULE_NAME}
                            />
                        </div>
                    </div>
                }
            </div>

            <DrawerComponent open={isImportPatientDrawerOpen}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             title={"Import Bulk Patient File"}
                             onClose={() => setIsImportPatientDrawerOpen(false)}
            >
                <>
                    <ImportBulkPatientComponent
                        onImportDrawerClose={() => {
                            setIsImportPatientDrawerOpen(false)
                        }}
                        type={'reUpload'}
                        bulkOrderDetails={bulkOrderDetails}/>
                </>
            </DrawerComponent>
            <DialogComponent
                open={patientModalConfig.isOpen}
                direction={"down"}
                isShowCancel={false}
                maxWidth={'sm'}
            >
                <>
                    <div className={'result-preview-dialog'}>
                        <div className={'result-preview-dialog-image-wrapper'}>
                            <img src={ImageConfig.resultDialogImage} alt={'result'} className="result-dialog-image"/>
                        </div>
                        <div className={'result-preview-dialog-content-wrapper'}>
                            {patientModalConfig.progressCount} / {patientModalConfig.totalCount}
                        </div>
                        <div className={'result-preview-dialog-content-sub-header'}>
                            Patient are being {patientModalConfig.type === 'generating' ? 'generated' : 'uploaded'}...
                        </div>
                        {patientModalConfig.type === 'generating' &&
                            <div className={'result-preview-dialog-close-button'}>
                                <ButtonComponent
                                    type="button"
                                    color={"primary"}
                                    variant={"contained"}
                                    fullWidth={true}
                                    handleClick={() => navigate(CommonService._routeConfig.PatientListRoute())}
                                >
                                    Back to Patient List
                                </ButtonComponent>
                            </div>}
                    </div>
                </>
            </DialogComponent>
            <DialogComponent open={insuranceModalConfig.isOpen}
                             maxWidth={'xl'}
                             title={"Resolve Patient Insurance Conflict"}
                             isShowCancel={true}
                             onClose={() => {
                                 setInsuranceModalConfig(initialInsuranceModalConfig)
                                 getUpdatedListCount();
                             }}
                             className={"insurance-conflict"}>
                {insuranceModalConfig.isOpen && bulkPatientID &&
                    <PatientInsuranceConflictComponent bulkPatientID={bulkPatientID}/>}
            </DialogComponent>
        </div>
    );

};

export default BulkPatientViewComponent;
